import styled from "styled-components";

export const ContainerRadio = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

export const RadioButton = styled.div`

    input{
        all:unset;
        border-radius: 100%;
        height: 5px;
        width: 5px;

    }
    
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.off ? props.theme.backgrounds.white : '#D9D9D9' } ;
    cursor: pointer;
    border-radius: 100%;  
    border: ${props => props.off? `7px solid ${props.theme.backgrounds.red2}` : '7px solid #D9D9D9'};
    

`;
